// extracted by mini-css-extract-plugin
module.exports = {"forgottenPass":"page_forgottenPass__ZVcfB"};